import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { RootState } from '../../redux/store';
import { DashboardState } from '../../redux/reducers/DashboardReducer';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import DashboardChartContainer from './DashboardChartContainer';
import { ChartResponse } from '../../domain/chart/ChartDomains';
import EmptyComponent from '../custom/empty-components/EmptyComponent';
import ComponentName from '../../constant/ComponentName';
import GridLayout from 'react-grid-layout';
import { changeDashboard, changeEditMode } from '../../redux/actions/DashboardActions';
import DashboardRulePerformanceComponent from './DashboardRulePerformanceComponent';
import { ChartType } from '@trlogic/ui-pack';
import RoleHelper from '../../RoleHelper';
import { PageState } from '../../redux/reducers/PageReducer';
import CustomLoading from '../custom/CustomLoading';
import LanguageUtil from '../../util/LanguageUtil';

class DashboardComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const {
      dashboard: { response, dashboard, editMode, loading },
      changeDashboard,
    } = this.props;
    if ((!response || !response.charts || response.charts.length === 0 || !dashboard.name || dashboard.name === '') && !loading) {
      return (
        <div className={'flex w-full h-full py-5 px-5'}>
          <EmptyComponent createDisabled={true} type={ComponentName.CHART} />
        </div>
      );
    }

    if (!RoleHelper.canView(ComponentName.DASHBOARD)) {
      return;
    }

    return (
      <div className={'flex flex-col overflow-x-hidden w-full h-full'}>
        <div className={'flex w-full items-center px-5'}></div>
        {loading ? (
          <CustomLoading />
        ) : (
          <>
            <div>
              <GridLayout
                key={editMode + 'container'}
                className='layout h-full'
                cols={48}
                style={{ padding: '5px' }}
                width={this.state.width}
                rowHeight={50}
                onLayoutChange={(layout) => {
                  dashboard.layouts = layout;
                  changeDashboard(dashboard);
                }}
              >
                {response?.charts?.map((chart: ChartResponse, index: number) => {
                  let layout = {
                    i: chart.id,
                    x: 0,
                    y: index + 1,
                    w: 24,
                    h: 6,
                    isResizable: true,
                    isDraggable: RoleHelper.canEdit(ComponentName.DASHBOARD),
                    minW: 8,
                    minH: 3,
                    resizeHandles: ['se'],
                    static: false,
                  };
                  const isLayoutExist = dashboard?.layouts?.find((layout) => layout.i == chart.id);
                  if (isLayoutExist) {
                    layout = { ...isLayoutExist };
                  }
                  layout.minH = 3;
                  layout.minW = 8;
                  layout.isResizable = true;
                  layout.isDraggable = RoleHelper.canEdit(ComponentName.DASHBOARD);
                  const title = LanguageUtil.get({ id: `pages.dashboard.charts.test`, defaultMessage: chart.name });
                  console.log(title);
                  return (
                    <div className={'bg-white z-50'} key={chart.id} data-grid={layout}>
                      <DashboardChartContainer
                        isStaticChart={chart.isStaticChart}
                        dashboardName={dashboard.name}
                        segmentItem={chart.attributes?.segmentItem}
                        type={chart.type as ChartType}
                        chartName={title}
                        options={chart.attributes?.visualOptions}
                        metrics={chart?.attributes?.metricItem || []}
                        chartId={chart.id}
                        data={chart.result}
                      />
                    </div>
                  );
                })}
              </GridLayout>
            </div>
            <>
              <DashboardRulePerformanceComponent />
            </>
          </>
        )}
      </div>
    );
  }

  public handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth,
    });
  };

  public async componentDidMount() {
    this.getGridWidth();
    window.addEventListener('resize', this.handleResize);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  public async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.state.windowWidth != prevState.windowWidth || this.props.page.sidebarCollapsed != prevProps.page.sidebarCollapsed) {
      this.getGridWidth();
    }
  }

  private getGridWidth() {
    const {
      page: { sidebarCollapsed },
    } = this.props;
    const windowWidth = window.innerWidth;
    let sidebarWidth: number;
    if (windowWidth <= 1024) {
      sidebarWidth = 30;
    } else if (windowWidth <= 1536) {
      sidebarWidth = 191;
    } else {
      sidebarWidth = 251;
    }
    let width = windowWidth - sidebarWidth;
    const height = width * 0.14;
    if (sidebarCollapsed) {
      width = width + 140;
    }
    this.setState({ width: width, height: height });
  }
}

interface Props extends ReduxProps, FormicaProps {}

class State {
  width = 0;
  windowWidth = 0;
  height = 20;
}

const mapStateToProps = (state: RootState) => ({
  dashboard: state.dashboard as DashboardState,
  page: state.page as PageState,
});
const mapDispatchToProps = { changeDashboard, changeEditMode };

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default withFormica(connector(DashboardComponent));
